
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("b5voN", function(module, exports) {
$parcel$export(module.exports, "ReportsOverviewPage", () => $90d90150d6441894$export$b7ffbf45208791a3);

var $6e6qB = parcelRequire("6e6qB");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $FhXEJ = parcelRequire("FhXEJ");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2gvG4 = parcelRequire("2gvG4");

var $2imLM = parcelRequire("2imLM");

var $jKVxM = parcelRequire("jKVxM");

var $6nVJI = parcelRequire("6nVJI");

var $3nL89 = parcelRequire("3nL89");

var $7iHUq = parcelRequire("7iHUq");

var $cZTMg = parcelRequire("cZTMg");

var $4EKqI = parcelRequire("4EKqI");

var $5vQ2T = parcelRequire("5vQ2T");

var $lRq8t = parcelRequire("lRq8t");

var $gWu57 = parcelRequire("gWu57");

var $kGj4V = parcelRequire("kGj4V");
var $eS29z = parcelRequire("eS29z");

var $4cTDP = parcelRequire("4cTDP");

var $lKbC6 = parcelRequire("lKbC6");

var $6eeqI = parcelRequire("6eeqI");
const $90d90150d6441894$var$analyticsAttributes = {
    type: 'reports'
};
const $90d90150d6441894$export$b7ffbf45208791a3 = ({ queries: { reportsOverviewPage: queryReference } })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [{ data: containerContextData, error: error }] = (0, $6nVJI.useContainerContext)();
    const data = (0, $j4oe4.usePreloadedQuery)((0, $6e6qB.default), queryReference);
    const isBusinessProject = data.jira_projectByIdOrKey?.projectType === (0, $FhXEJ.JIRA_PROJECT_TYPE_CORE_PROJECT);
    const isTeamManagedProject = data.jira_projectByIdOrKey?.projectStyle === 'TEAM_MANAGED_PROJECT';
    const ufoCustomData = (0, $eJOHy.useMemo)(()=>{
        return {
            isBusinessProject: isBusinessProject,
            isTeamManagedProject: isTeamManagedProject,
            uxissue_545_migrate_tmp_reports_overview_page: (0, $4cTDP.fg)('uxissue_545_migrate_tmp_reports_overview_page')
        };
    }, [
        isBusinessProject,
        isTeamManagedProject
    ]);
    if (!containerContextData || error || !queryReference) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
        name: "jira-reports-overview-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
        data: ufoCustomData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $90d90150d6441894$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
        id: "jira-summary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $6eeqI.default).documentTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "reports-overview-page",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jKVxM.ReportsOverviewSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "software"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "reportsOverviewPage",
        packageName: "jiraReportsOverviewPage",
        teamName: "helios"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceName: "allReports",
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        attributes: {
            isBusinessProject: isBusinessProject,
            isTeamManagedProject: isTeamManagedProject
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lKbC6.ReportCategories), {
        reportCategoriesData: data
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS29z.FireScreenAnalytics), {
        attributes: $90d90150d6441894$var$analyticsAttributes
    }))))))));
};
const $90d90150d6441894$var$wrapperStyles = (0, $1DXK0.xcss)({
    overflow: 'auto',
    height: '100%'
});

});
parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("gWu57", function(module, exports) {
$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.300"
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: [
            hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStyles,
            (0, $4cTDP.fg)('global_rovo_button_in_jira') && $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles
        ]
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});
const $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.500'
});

});

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("lKbC6", function(module, exports) {
$parcel$export(module.exports, "ReportCategories", () => $71e29c1aa5fe001e$export$12d1781fc37720b8);

var $3LIdr = parcelRequire("3LIdr");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5vQ2T = parcelRequire("5vQ2T");

var $2mHfh = parcelRequire("2mHfh");

var $cSXp8 = parcelRequire("cSXp8");

var $lRq8t = parcelRequire("lRq8t");

var $iipyU = parcelRequire("iipyU");

var $eeuk4 = parcelRequire("eeuk4");
const $71e29c1aa5fe001e$export$12d1781fc37720b8 = ({ reportCategoriesData: reportCategoriesData })=>{
    const { showFlag: showFlag } = (0, $cSXp8.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const data = (0, $j4oe4.useFragment)((0, $3LIdr.default), reportCategoriesData);
    let categories;
    const projectQueryErrors = data.jira_projectByIdOrKey?.reportCategories?.errors ?? [];
    if (projectQueryErrors.length > 0) {
        const worstStatusCode = projectQueryErrors.flatMap((errors)=>errors.extensions).map((extension)=>extension?.statusCode ?? 0).reduce((prev, curr)=>{
            return Math.max(prev, curr);
        }, 0);
        if (worstStatusCode >= 500) throw new Error('5xx error returned for reports overview project query');
        if (worstStatusCode >= 400) {
            showFlag({
                id: 'reportCategoriesOverviewQueryError',
                type: 'error',
                title: formatMessage((0, $eeuk4.default).projectNotFoundErrorFlagTitle),
                description: formatMessage((0, $eeuk4.default).projectNotFoundErrorFlagMessage),
                messageId: 'reports-overview-page.ui.report-categories.show-flag.error.report-categories-overview-query-error.show-flag.error.1',
                messageType: 'transactional'
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2mHfh.Redirect), {
                to: "/jira/your-work"
            });
        }
    }
    if (data.jira_projectByIdOrKey?.reportCategories?.edges) categories = data.jira_projectByIdOrKey.reportCategories.edges.flatMap((categoryEdge)=>categoryEdge?.node ? [
            categoryEdge.node
        ] : []);
    else if (data.jira?.jiraBoard.reportCategories?.edges) categories = data.jira.jiraBoard.reportCategories?.edges.flatMap((categoryEdge)=>categoryEdge?.node ? [
            categoryEdge.node
        ] : []);
    if (!categories) throw new Error('reportCategoriesQuery returned no data');
    const shouldShowHeading = categories && categories.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, categories.map((category)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            key: category.name,
            id: "reportsOverviewPageReportCategory",
            packageName: "jiraReportsOverviewPage",
            teamName: "helios",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iipyU.ReportCategory), {
            category: category,
            shouldShowHeading: shouldShowHeading
        }))));
};

});
parcelRegister("3LIdr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a33441712a41a655$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dbc51c8864d67c2c2b3ed9ce8d751458>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a33441712a41a655$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    }, v1 = {
        "kind": "FragmentSpread",
        "name": "reportCategory_reportsOverviewPage"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "boardId"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "isBoardContext"
            },
            {
                "kind": "RootArgument",
                "name": "projectKey"
            }
        ],
        "kind": "Fragment",
        "name": "reportCategories_reportsOverviewPage",
        "selections": [
            {
                "condition": "isBoardContext",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "idOrKey",
                                    "variableName": "projectKey"
                                }
                            ],
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jira_projectByIdOrKey",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "concreteType": "JiraReportCategoryConnection",
                                        "kind": "LinkedField",
                                        "name": "reportCategories",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "kind": "LinkedField",
                                                            "name": "extensions",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCode"
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "jira_projectByIdOrKey.reportCategories.errors.extensions.statusCode"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira_projectByIdOrKey.reportCategories.errors.extensions"
                                                    }
                                                ]
                                            },
                                            {
                                                "concreteType": "JiraReportCategoryEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraReportCategoryNode",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v0 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira_projectByIdOrKey.reportCategories.edges.node.name"
                                                            },
                                                            v1 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira_projectByIdOrKey.reportCategories"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira_projectByIdOrKey"
                    }
                ]
            },
            {
                "condition": "isBoardContext",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraQuery",
                            "kind": "LinkedField",
                            "name": "jira",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "id",
                                                "variableName": "boardId"
                                            }
                                        ],
                                        "kind": "LinkedField",
                                        "name": "jiraBoard",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraReportCategoryConnection",
                                                            "kind": "LinkedField",
                                                            "name": "reportCategories",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraReportCategoryEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraReportCategoryNode",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v0 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.jiraBoard.reportCategories.edges.node.name"
                                                                                    },
                                                                                    v1 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.jiraBoard.reportCategories.edges.node"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "jira.jiraBoard.reportCategories"
                                                    }
                                                ],
                                                "type": "JiraBoard"
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "jira.jiraBoard"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "jira"
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$a33441712a41a655$var$node.hash = "c24384adae5f380365f9cbf8a99e2c25";
var $a33441712a41a655$export$2e2bcd8739ae039 = $a33441712a41a655$var$node;

});

parcelRegister("iipyU", function(module, exports) {
$parcel$export(module.exports, "ReportCategory", () => $410170b94e0d18db$export$558a0cecffe77f00);

var $govRe = parcelRequire("govRe");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $806LH = parcelRequire("806LH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");

var $5vQ2T = parcelRequire("5vQ2T");

var $gy1Ls = parcelRequire("gy1Ls");
const $410170b94e0d18db$export$558a0cecffe77f00 = ({ category: category, shouldShowHeading: shouldShowHeading })=>{
    const reportCategory = (0, $j4oe4.useFragment)((0, $govRe.default), category);
    const reports = reportCategory.reports.edges.flatMap((reportEdge)=>reportEdge && reportEdge.node && reportEdge.node.__typename === 'JiraReport' ? [
            reportEdge.node
        ] : []);
    const shouldShowHeadingForCategory = reports.length > 0 && shouldShowHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        as: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: "reportsOverviewPageReportHeading",
        packageName: "jiraReportsOverviewPage",
        teamName: "helios",
        fallback: "unmount"
    }, shouldShowHeadingForCategory && ((0, $4cTDP.fg)('reports-overview-heading-contrast') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("h2", {
        className: (0, $hcewu.default)([
            "_11q71iew _11c8lodh _2rko12b0 _syazfrbu _ca0qv77o _n3tdv77o _19bvu2gc _u5f3u2gc _19pk1i6y _otyr1i6y _18u0x0bf _2hwxx0bf _1bsb1ns9"
        ])
    }, reportCategory.name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_11q71iew _11c8lodh _2rko12b0 _syazfrbu _ca0qv77o _n3tdv77o _19bvu2gc _u5f3u2gc _19pk1i6y _otyr1i6y _18u0x0bf _2hwxx0bf _1bsb1ns9"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        as: "h2",
        size: "medium"
    }, reportCategory.name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $410170b94e0d18db$var$gridContainerStyles,
        paddingBlockStart: "space.200",
        paddingBlockEnd: "space.400"
    }, reports.map((report)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
            key: report.name,
            id: "reportsOverviewPageReportCard",
            packageName: "jiraReportsOverviewPage",
            teamName: "helios",
            fallback: "unmount"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gy1Ls.ReportCard), {
            report: report,
            isRedesignVisible: (0, $4cTDP.fg)('uxissue_545_migrate_tmp_reports_overview_page')
        })))));
};
const $410170b94e0d18db$var$headingStyles = null;
const $410170b94e0d18db$var$gridContainerStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 'space.300',
    alignItems: 'start',
    maxWidth: '3000px'
});

});
parcelRegister("govRe", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5efc6a0d0626256$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<21fa1769b9b61c08f056bce947877848>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f5efc6a0d0626256$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "reportCategory_reportsOverviewPage",
        "selections": [
            {
                "kind": "RequiredField",
                "field": v0 /*: any*/ ,
                "action": "THROW",
                "path": "name"
            },
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraReportConnection",
                    "kind": "LinkedField",
                    "name": "reports",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "concreteType": "JiraReportConnectionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "concreteType": "JiraReport",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v0 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "reports.edges.node.name"
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "reportCard_reportsOverviewPage"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "reports.edges.node"
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "reports.edges"
                        }
                    ]
                },
                "action": "THROW",
                "path": "reports"
            }
        ],
        "type": "JiraReportCategoryNode"
    };
}();
$f5efc6a0d0626256$var$node.hash = "8f7729322daa1ba2c2a98fc5715fd793";
var $f5efc6a0d0626256$export$2e2bcd8739ae039 = $f5efc6a0d0626256$var$node;

});

parcelRegister("gy1Ls", function(module, exports) {
$parcel$export(module.exports, "ReportCard", () => $66cfbfa1307bd091$export$7bf364c5d17ecc34);

var $ejhAF = parcelRequire("ejhAF");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $4CEkC = parcelRequire("4CEkC");

var $j4oe4 = parcelRequire("j4oe4");

var $4A4K2 = parcelRequire("4A4K2");

var $lL4G9 = parcelRequire("lL4G9");
var $dW738 = parcelRequire("dW738");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $lc0OY = parcelRequire("lc0OY");
var $78OnL = parcelRequire("78OnL");
var $3cMgR = parcelRequire("3cMgR");

var $eJ9f5 = parcelRequire("eJ9f5");

var $806LH = parcelRequire("806LH");

var $k71qx = parcelRequire("k71qx");

var $jdqdp = parcelRequire("jdqdp");

var $kRgKj = parcelRequire("kRgKj");
var $ftN6c = parcelRequire("ftN6c");

var $6nVJI = parcelRequire("6nVJI");

var $2aY2d = parcelRequire("2aY2d");

var $lRq8t = parcelRequire("lRq8t");

var $4cTDP = parcelRequire("4cTDP");

var $b4yTl = parcelRequire("b4yTl");

var $8eIcn = parcelRequire("8eIcn");

var $6eeqI = parcelRequire("6eeqI");

var $2lJL8 = parcelRequire("2lJL8");
const $66cfbfa1307bd091$var$useTMPReportUrl = (reportKey)=>{
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const boardId = (0, $4A4K2.useBoardId)();
    const projectKey = projectData?.projectKey;
    if (!projectKey || !boardId) return undefined;
    if (reportKey === 'burndown') return `/jira/software/projects/${projectKey}/boards/${boardId}/reports/${reportKey}?source=overview`;
    return `/jira/software/projects/${projectKey}/boards/${boardId}/reports/${reportKey}`;
};
const $66cfbfa1307bd091$var$usePrettyReportUrl = (url)=>{
    const [{ data: data, error: error }] = (0, $6nVJI.useContainerContext)();
    const urlObj = new URL(url, globalThis.window.location.origin);
    const queryParams = Object.fromEntries(urlObj.searchParams.entries());
    if (!data || error || !queryParams.view) return url;
    let prettyUrl = ''; // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (!data.project) // @ts-expect-error - TS2339 - Property 'user' does not exist on type 'ContainerContext'.
    prettyUrl += `/jira/people/${data.user.accountId}`;
    else // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    prettyUrl += `/jira/software/c/projects/${data.project.key}`;
    prettyUrl += `/boards/${data.scope?.id}/reports/${(0, (/*@__PURE__*/$parcel$interopDefault($4CEkC)))(queryParams.chart)}`;
    return prettyUrl;
};
const $66cfbfa1307bd091$export$7bf364c5d17ecc34 = ({ report: report, isRedesignVisible: isRedesignVisible })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { data: projectData } = (0, $2aY2d.useProjectContext)();
    const intl = (0, $lRq8t.default)();
    const reportCardData = (0, $j4oe4.useFragment)((0, $ejhAF.default), report);
    const name = reportCardData.name;
    const description = reportCardData.description;
    const isTeamManaged = projectData?.simplified || false;
    const prettyUrl = $66cfbfa1307bd091$var$usePrettyReportUrl(reportCardData.url);
    const tmpUrl = $66cfbfa1307bd091$var$useTMPReportUrl(reportCardData.url);
    const url = (0, $eJOHy.useMemo)(()=>{
        if (isTeamManaged && tmpUrl && (0, $4cTDP.fg)('uxissue_545_migrate_tmp_reports_overview_page')) return tmpUrl;
        return prettyUrl;
    }, [
        isTeamManaged,
        tmpUrl,
        prettyUrl
    ]);
    const { isNotApplicableReason: isNotApplicableReason, isNotApplicableDesc: isNotApplicableDesc, key: reportKey } = reportCardData;
    const fireReportClickedAnalytics = (0, $eJOHy.useCallback)(()=>{
        (0, $kRgKj.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'reportButton', {
            report: name
        });
    }, [
        createAnalyticsEvent,
        name
    ]);
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        fireReportClickedAnalytics();
    }, [
        fireReportClickedAnalytics
    ]);
    if (isRedesignVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $66cfbfa1307bd091$var$styles.root,
            !isNotApplicableReason && $66cfbfa1307bd091$var$styles.rootHover
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $66cfbfa1307bd091$var$styles.imageContainer
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2lJL8.ReportCardImage), {
        report: reportCardData
    }), isNotApplicableReason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $66cfbfa1307bd091$var$styles.lozenge
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: `${isNotApplicableReason}. ${isNotApplicableDesc}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "moved",
        isBold: true
    }, isNotApplicableReason))) : null), isNotApplicableReason ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lc0OY.default), {
        href: url,
        onClick: handleClick,
        "aria-label": name,
        xcss: $66cfbfa1307bd091$var$styles.link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "medium",
        as: "p"
    }, description), isNotApplicableReason && reportKey === (0, $8eIcn.CYCLE_TIME_REPORT_KEY) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: (0, $8eIcn.CI_CD_GET_STARTED_LINK),
        target: "_blank"
    }, intl.formatMessage((0, $6eeqI.default).learnMore))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lL4G9.default), {
        xcss: $66cfbfa1307bd091$var$oldCardStyles,
        href: url,
        onClick: handleClick,
        "aria-label": name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dW738.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b4yTl.ReportImage), {
        report: reportCardData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xsmall",
        as: "h3"
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
        size: "medium",
        as: "p"
    }, description)));
};
const $66cfbfa1307bd091$var$styles = {
    root: "_2rko1mok _1h6d1l7x _1dqonqa1 _189ee4h9 _kqswh2mm _vchhusvi _4t3inklw _1bsb1ogy _1e0c1txw _18m91wug _2lx21bp4 _19bvutpp _u5f3utpp _ca0qutpp _n3tdutpp _bfhk1bhr",
    rootHover: "_jyzf1v1w _9oik18uv _1bnxglyw _jf4cnqa1 _4cvx1v1w",
    link: "_4bfu18uv _1hmsglyw _ajmmnqa1 _kqswpfqs _1x88idpf _aetrb3bt _19doidpf _18postnw _32rxidpf _15l2idpf _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _vjfr18uv _10xfglyw _1w0vnqa1 _mizu1r31 _ra3xglyw _128m1o36 _9oik18uv _1bnxglyw _jf4cnqa1",
    lozenge: "_kqswstnw _94n5u2gc _1xi2u2gc",
    imageContainer: "_kqswh2mm"
};
const $66cfbfa1307bd091$var$oldCardStyles = (0, $1DXK0.xcss)({
    height: '320px',
    width: '270px',
    display: 'flex',
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'hidden',
    paddingLeft: 'space.150',
    paddingRight: 'space.150',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    border: '2px solid',
    borderColor: 'color.border',
    borderRadius: 'radius.large',
    backgroundColor: 'elevation.surface.overlay',
    ':hover': {
        borderColor: 'color.border.focused',
        borderStyle: 'solid',
        borderWidth: 'space.025',
        overflowY: 'auto',
        textDecoration: 'none'
    },
    ':focus-within': {
        borderColor: 'color.border.focused',
        borderStyle: 'solid',
        borderWidth: 'space.025',
        overflowY: 'auto',
        outline: 'none',
        textDecoration: 'none'
    },
    textDecoration: 'none'
});

});
parcelRegister("ejhAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ffb437425ed8533c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1437eb8ddcd1b99de0b299afed914914>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ffb437425ed8533c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isMigrateTMPReportsOverviewEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "reportCard_reportsOverviewPage",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "reportImage_reportsOverviewPage"
        },
        {
            "kind": "FragmentSpread",
            "name": "image_reportsOverviewPage_ReportCardImage"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "description"
            },
            "action": "THROW",
            "path": "description"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "url"
            },
            "action": "THROW",
            "path": "url"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "condition": "isMigrateTMPReportsOverviewEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isNotApplicableReason"
                },
                {
                    "kind": "ScalarField",
                    "name": "isNotApplicableDesc"
                }
            ]
        }
    ],
    "type": "JiraReport"
};
$ffb437425ed8533c$var$node.hash = "6aa389c95744f9c0e24ffb5ddea80396";
var $ffb437425ed8533c$export$2e2bcd8739ae039 = $ffb437425ed8533c$var$node;

});

parcelRegister("4A4K2", function(module, exports) {
$parcel$export(module.exports, "useBoardId", () => $021c762eb0fc5e9f$export$b49754504c41149f);

var $gCY1z = parcelRequire("gCY1z");
const $021c762eb0fc5e9f$export$b49754504c41149f = ()=>{
    const [{ match: { params: params } }] = (0, $gCY1z.useRouter)();
    return Number(params.boardId) || null;
};

});

parcelRegister("b4yTl", function(module, exports) {
$parcel$export(module.exports, "ReportImage", () => $d6b960ea10e830d1$export$3a1b95a323444eea);

var $caakC = parcelRequire("caakC");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8wyVH = parcelRequire("8wyVH");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $8eIcn = parcelRequire("8eIcn");

var $3JHxT = parcelRequire("3JHxT");
const $d6b960ea10e830d1$export$3a1b95a323444eea = ({ report: report })=>{
    const reportData = (0, $j4oe4.useFragment)((0, $caakC.default), report);
    const key = reportData.key;
    const name = reportData.name;
    const url = reportData.imageUrl;
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d6b960ea10e830d1$var$imageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: url,
        width: (0, $8eIcn.IMAGE_WIDTH),
        height: (0, $8eIcn.IMAGE_HEIGHT),
        alt: name
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $d6b960ea10e830d1$var$imageStyles
    }, (0, $3JHxT.getImageForKey)(key, name));
};
const $d6b960ea10e830d1$var$imageStyles = (0, $1DXK0.xcss)({
    height: '144px',
    overflow: 'hidden'
});

});
parcelRegister("caakC", function(module, exports) {
$parcel$export(module.exports, "default", () => $793dd12ac4d63199$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97f1e9b3fed7d644c6c475e3944c775e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $793dd12ac4d63199$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "reportImage_reportsOverviewPage",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "kind": "ScalarField",
            "name": "imageUrl"
        }
    ],
    "type": "JiraReport"
};
$793dd12ac4d63199$var$node.hash = "1bc97c3705a9a5fa1d99b4071832ba2a";
var $793dd12ac4d63199$export$2e2bcd8739ae039 = $793dd12ac4d63199$var$node;

});

parcelRegister("8eIcn", function(module, exports) {
$parcel$export(module.exports, "IMAGE_WIDTH", () => $d4d5d3047a3de68d$export$400c0bab3c921266);
$parcel$export(module.exports, "IMAGE_HEIGHT", () => $d4d5d3047a3de68d$export$11c28e35a0c89402);
$parcel$export(module.exports, "CYCLE_TIME_REPORT_KEY", () => $d4d5d3047a3de68d$export$e66b3c5582e30d5a);
$parcel$export(module.exports, "CI_CD_GET_STARTED_LINK", () => $d4d5d3047a3de68d$export$680ecd58059dceb1);
const $d4d5d3047a3de68d$var$REPORT_WIDTH = 32;
const $d4d5d3047a3de68d$var$REPORT_HEIGHT = 36;
const $d4d5d3047a3de68d$var$reportHeightGridUnits = $d4d5d3047a3de68d$var$REPORT_HEIGHT / 2;
const $d4d5d3047a3de68d$export$400c0bab3c921266 = 8 * $d4d5d3047a3de68d$var$REPORT_WIDTH;
const $d4d5d3047a3de68d$export$11c28e35a0c89402 = 8 * $d4d5d3047a3de68d$var$reportHeightGridUnits;
const $d4d5d3047a3de68d$export$e66b3c5582e30d5a = 'jsw.report.cycle-time';
const $d4d5d3047a3de68d$export$680ecd58059dceb1 = 'https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started';

});

parcelRegister("3JHxT", function(module, exports) {
$parcel$export(module.exports, "getImageForKey", () => $3d56789105be0454$export$2683e480e2fced24);

var $eJOHy = parcelRequire("eJOHy");

var $e3tVN = parcelRequire("e3tVN");

var $6kO5A = parcelRequire("6kO5A");

var $5Mztd = parcelRequire("5Mztd");

var $lGmw9 = parcelRequire("lGmw9");

var $iVLML = parcelRequire("iVLML");

var $jgc5J = parcelRequire("jgc5J");

var $iPysn = parcelRequire("iPysn");

var $efQtr = parcelRequire("efQtr");

var $biHVL = parcelRequire("biHVL");

var $jnMPp = parcelRequire("jnMPp");

var $1Jkpe = parcelRequire("1Jkpe");

var $heFJj = parcelRequire("heFJj");

var $lGWb1 = parcelRequire("lGWb1");

var $1OECz = parcelRequire("1OECz");

var $85cjN = parcelRequire("85cjN");

var $5hsmE = parcelRequire("5hsmE");

var $a9fgK = parcelRequire("a9fgK");

var $d8W32 = parcelRequire("d8W32");

var $4BIjN = parcelRequire("4BIjN");

var $58Wue = parcelRequire("58Wue");

var $bm7LM = parcelRequire("bm7LM");

var $djktQ = parcelRequire("djktQ");

var $9C1OB = parcelRequire("9C1OB");

var $8eIcn = parcelRequire("8eIcn");
function $3d56789105be0454$export$2683e480e2fced24(key, alt) {
    switch(key){
        case 'com.pyxis.greenhopper.jira:agile-burndown-chart':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kO5A.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-sprint-burnup':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Mztd.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-sprint-retrospective':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $heFJj.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-velocity-chart':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGmw9.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-cumulative-flow-diagram':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iVLML.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-version-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iPysn.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-epic-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9C1OB.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-control-chart':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1Jkpe.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-epic-burndown':
        case 'com.pyxis.greenhopper.jira:agile-release-burndown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $biHVL.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-cycletime-chart':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efQtr.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.pyxis.greenhopper.jira:agile-deployment-frequency-chart':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jgc5J.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:averageage-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGWb1.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:createdvsresolved-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a9fgK.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:pie-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1OECz.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:recentlycreated-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85cjN.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:resolutiontime-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5hsmE.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:singlelevelgroupby':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $d8W32.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:timesince-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4BIjN.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:time-tracking':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $58Wue.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugin.system.reports:developer-workload':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bm7LM.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.plugins.jira-software-plugin:version-workload-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $djktQ.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'com.atlassian.jira.ext.charting:workloadpie-report':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e3tVN.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.sprint-burndown':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6kO5A.default), {
                alt: alt,
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.sprint-burnup':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Mztd.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.velocity':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGmw9.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.cumulative.flow.diagram':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iVLML.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.deployment-frequency':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jgc5J.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.cycle-time':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $efQtr.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        case 'jsw.report.control':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jnMPp.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e3tVN.default), {
                alt: alt,
                height: (0, $8eIcn.IMAGE_HEIGHT),
                width: (0, $8eIcn.IMAGE_WIDTH)
            });
    }
}

});
parcelRegister("e3tVN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a91b49738626aab$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $9DmKe = parcelRequire("9DmKe");
const $4a91b49738626aab$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9DmKe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9DmKe))
});
var $4a91b49738626aab$export$2e2bcd8739ae039 = $4a91b49738626aab$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $4a91b49738626aab$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("9DmKe", function(module, exports) {
module.exports = new URL("report-default.ef0cd7c2.svg", import.meta.url).toString();

});


parcelRegister("6kO5A", function(module, exports) {
$parcel$export(module.exports, "default", () => $baf705448c2cea73$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $5SvPp = parcelRequire("5SvPp");
const $baf705448c2cea73$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5SvPp)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($5SvPp))
});
var $baf705448c2cea73$export$2e2bcd8739ae039 = $baf705448c2cea73$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $baf705448c2cea73$export$a179c88182cb9d56 = [
    0,
    0,
    209,
    119
];

});
parcelRegister("5SvPp", function(module, exports) {
module.exports = new URL("report-burndown.972f8546.svg", import.meta.url).toString();

});


parcelRegister("5Mztd", function(module, exports) {
$parcel$export(module.exports, "default", () => $edbfb210be250bfe$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $dsHsU = parcelRequire("dsHsU");
const $edbfb210be250bfe$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($dsHsU)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($dsHsU))
});
var $edbfb210be250bfe$export$2e2bcd8739ae039 = $edbfb210be250bfe$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $edbfb210be250bfe$export$a179c88182cb9d56 = [
    0,
    0,
    209,
    120
];

});
parcelRegister("dsHsU", function(module, exports) {
module.exports = new URL("report-burnup.d56fdf25.svg", import.meta.url).toString();

});


parcelRegister("lGmw9", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf07f8598ca347fd$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $7aAxo = parcelRequire("7aAxo");
const $cf07f8598ca347fd$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($7aAxo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7aAxo))
});
var $cf07f8598ca347fd$export$2e2bcd8739ae039 = $cf07f8598ca347fd$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $cf07f8598ca347fd$export$a179c88182cb9d56 = [
    0,
    0,
    209,
    118
];

});
parcelRegister("7aAxo", function(module, exports) {
module.exports = new URL("report-velocity.af32d9e6.svg", import.meta.url).toString();

});


parcelRegister("iVLML", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd2b25532a7e0e26$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $3eTOt = parcelRequire("3eTOt");
const $dd2b25532a7e0e26$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($3eTOt)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3eTOt))
});
var $dd2b25532a7e0e26$export$2e2bcd8739ae039 = $dd2b25532a7e0e26$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $dd2b25532a7e0e26$export$a179c88182cb9d56 = [
    0,
    0,
    417,
    214
];

});
parcelRegister("3eTOt", function(module, exports) {
module.exports = new URL("report-cumulative-flow-diagram.d1059572.svg", import.meta.url).toString();

});


parcelRegister("jgc5J", function(module, exports) {
$parcel$export(module.exports, "default", () => $26bcc96c90d35f80$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $4ETBd = parcelRequire("4ETBd");
const $26bcc96c90d35f80$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($4ETBd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($4ETBd))
});
var $26bcc96c90d35f80$export$2e2bcd8739ae039 = $26bcc96c90d35f80$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $26bcc96c90d35f80$export$a179c88182cb9d56 = [
    0,
    0,
    270,
    142
];

});
parcelRegister("4ETBd", function(module, exports) {
module.exports = new URL("report-deployment-frequency.48f7b022.svg", import.meta.url).toString();

});


parcelRegister("iPysn", function(module, exports) {
$parcel$export(module.exports, "default", () => $7118b4f5fa37d595$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $hJ4p6 = parcelRequire("hJ4p6");
const $7118b4f5fa37d595$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($hJ4p6)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($hJ4p6))
});
var $7118b4f5fa37d595$export$2e2bcd8739ae039 = $7118b4f5fa37d595$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $7118b4f5fa37d595$export$a179c88182cb9d56 = [
    25,
    -7,
    225,
    158
];

});
parcelRegister("hJ4p6", function(module, exports) {
module.exports = new URL("report-version.0a75365e.svg", import.meta.url).toString();

});


parcelRegister("efQtr", function(module, exports) {
$parcel$export(module.exports, "default", () => $829cc8df9164e4d0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $8p0g1 = parcelRequire("8p0g1");
const $829cc8df9164e4d0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8p0g1)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8p0g1))
});
var $829cc8df9164e4d0$export$2e2bcd8739ae039 = $829cc8df9164e4d0$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $829cc8df9164e4d0$export$a179c88182cb9d56 = [
    0,
    -15,
    270,
    142
];

});
parcelRegister("8p0g1", function(module, exports) {
module.exports = new URL("report-cycle-time.13464e88.svg", import.meta.url).toString();

});


parcelRegister("biHVL", function(module, exports) {
$parcel$export(module.exports, "default", () => $44e2aee16bf9b517$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $2yBtd = parcelRequire("2yBtd");
const $44e2aee16bf9b517$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2yBtd)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2yBtd))
});
var $44e2aee16bf9b517$export$2e2bcd8739ae039 = $44e2aee16bf9b517$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $44e2aee16bf9b517$export$a179c88182cb9d56 = [
    0,
    -10,
    270,
    140
];

});
parcelRegister("2yBtd", function(module, exports) {
module.exports = new URL("report-epic-or-release-burndown.678f9aa2.svg", import.meta.url).toString();

});


parcelRegister("jnMPp", function(module, exports) {
$parcel$export(module.exports, "default", () => $07d13b86afd039eb$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $2wBO8 = parcelRequire("2wBO8");
const $07d13b86afd039eb$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($2wBO8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($2wBO8))
});
var $07d13b86afd039eb$export$2e2bcd8739ae039 = $07d13b86afd039eb$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $07d13b86afd039eb$export$a179c88182cb9d56 = [
    0,
    0,
    542,
    248
];

});
parcelRegister("2wBO8", function(module, exports) {
module.exports = new URL("report-control-avp.dc825a04.svg", import.meta.url).toString();

});


parcelRegister("1Jkpe", function(module, exports) {
$parcel$export(module.exports, "default", () => $788044460b34b82e$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $ab8TR = parcelRequire("ab8TR");
const $788044460b34b82e$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ab8TR)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ab8TR))
});
var $788044460b34b82e$export$2e2bcd8739ae039 = $788044460b34b82e$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $788044460b34b82e$export$a179c88182cb9d56 = [
    20,
    0,
    230,
    148
];

});
parcelRegister("ab8TR", function(module, exports) {
module.exports = new URL("report-control-classic.fa1bb335.svg", import.meta.url).toString();

});


parcelRegister("heFJj", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c48beed30a7296b$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $zew0j = parcelRequire("zew0j");
const $2c48beed30a7296b$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($zew0j)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($zew0j))
});
var $2c48beed30a7296b$export$2e2bcd8739ae039 = $2c48beed30a7296b$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $2c48beed30a7296b$export$a179c88182cb9d56 = [
    20,
    10,
    209,
    119
];

});
parcelRegister("zew0j", function(module, exports) {
module.exports = new URL("report-sprint.2fdeee2a.svg", import.meta.url).toString();

});


parcelRegister("lGWb1", function(module, exports) {
$parcel$export(module.exports, "default", () => $b107cec3298a18b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $jlLT8 = parcelRequire("jlLT8");
const $b107cec3298a18b0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jlLT8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jlLT8))
});
var $b107cec3298a18b0$export$2e2bcd8739ae039 = $b107cec3298a18b0$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $b107cec3298a18b0$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("jlLT8", function(module, exports) {
module.exports = new URL("report-average-age.f0063cee.svg", import.meta.url).toString();

});


parcelRegister("1OECz", function(module, exports) {
$parcel$export(module.exports, "default", () => $617f309ff3f03a14$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $figM8 = parcelRequire("figM8");
const $617f309ff3f03a14$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($figM8)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($figM8))
});
var $617f309ff3f03a14$export$2e2bcd8739ae039 = $617f309ff3f03a14$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $617f309ff3f03a14$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("figM8", function(module, exports) {
module.exports = new URL("report-pie-chart.c26eec16.svg", import.meta.url).toString();

});


parcelRegister("85cjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $4040fb1a7a047ebe$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $ejaUj = parcelRequire("ejaUj");
const $4040fb1a7a047ebe$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($ejaUj)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ejaUj))
});
var $4040fb1a7a047ebe$export$2e2bcd8739ae039 = $4040fb1a7a047ebe$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $4040fb1a7a047ebe$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("ejaUj", function(module, exports) {
module.exports = new URL("report-recently-created-issues.6436ced2.svg", import.meta.url).toString();

});


parcelRegister("5hsmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8ed3b62fe02e942$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $1yErv = parcelRequire("1yErv");
const $d8ed3b62fe02e942$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1yErv)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1yErv))
});
var $d8ed3b62fe02e942$export$2e2bcd8739ae039 = $d8ed3b62fe02e942$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $d8ed3b62fe02e942$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("1yErv", function(module, exports) {
module.exports = new URL("report-resolution-time.77b24ed9.svg", import.meta.url).toString();

});


parcelRegister("a9fgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $d22e76217f15f285$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $8Woe0 = parcelRequire("8Woe0");
const $d22e76217f15f285$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8Woe0)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8Woe0))
});
var $d22e76217f15f285$export$2e2bcd8739ae039 = $d22e76217f15f285$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $d22e76217f15f285$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("8Woe0", function(module, exports) {
module.exports = new URL("report-created-vs-resolved.75277fe6.svg", import.meta.url).toString();

});


parcelRegister("d8W32", function(module, exports) {
$parcel$export(module.exports, "default", () => $06b025c4873375f0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $eYBM2 = parcelRequire("eYBM2");
const $06b025c4873375f0$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($eYBM2)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eYBM2))
});
var $06b025c4873375f0$export$2e2bcd8739ae039 = $06b025c4873375f0$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $06b025c4873375f0$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("eYBM2", function(module, exports) {
module.exports = new URL("report-single-level-group-by.00911765.svg", import.meta.url).toString();

});


parcelRegister("4BIjN", function(module, exports) {
$parcel$export(module.exports, "default", () => $07b7936f8fec9c5d$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $6UVQC = parcelRequire("6UVQC");
const $07b7936f8fec9c5d$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($6UVQC)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6UVQC))
});
var $07b7936f8fec9c5d$export$2e2bcd8739ae039 = $07b7936f8fec9c5d$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $07b7936f8fec9c5d$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("6UVQC", function(module, exports) {
module.exports = new URL("report-time-since.657aa64d.svg", import.meta.url).toString();

});


parcelRegister("58Wue", function(module, exports) {
$parcel$export(module.exports, "default", () => $afb2009b491fb05b$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $8THKQ = parcelRequire("8THKQ");
const $afb2009b491fb05b$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8THKQ)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8THKQ))
});
var $afb2009b491fb05b$export$2e2bcd8739ae039 = $afb2009b491fb05b$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $afb2009b491fb05b$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("8THKQ", function(module, exports) {
module.exports = new URL("report-time-tracking.32d7b653.svg", import.meta.url).toString();

});


parcelRegister("bm7LM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c60b5c109fee7bfe$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $8OhhW = parcelRequire("8OhhW");
const $c60b5c109fee7bfe$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($8OhhW)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($8OhhW))
});
var $c60b5c109fee7bfe$export$2e2bcd8739ae039 = $c60b5c109fee7bfe$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $c60b5c109fee7bfe$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("8OhhW", function(module, exports) {
module.exports = new URL("report-user-workload.f1dbe170.svg", import.meta.url).toString();

});


parcelRegister("djktQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f9838a2d803ac14$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $jhqYg = parcelRequire("jhqYg");
const $3f9838a2d803ac14$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jhqYg)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($jhqYg))
});
var $3f9838a2d803ac14$export$2e2bcd8739ae039 = $3f9838a2d803ac14$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $3f9838a2d803ac14$export$a179c88182cb9d56 = [
    0,
    0,
    228,
    138
];

});
parcelRegister("jhqYg", function(module, exports) {
module.exports = new URL("report-version-workload.f7f86d40.svg", import.meta.url).toString();

});


parcelRegister("9C1OB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e62b6089fb2953cf$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $c4huj = parcelRequire("c4huj");

var $demeN = parcelRequire("demeN");
const $e62b6089fb2953cf$var$Illustration = (0, $c4huj.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($demeN)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($demeN))
});
var $e62b6089fb2953cf$export$2e2bcd8739ae039 = $e62b6089fb2953cf$var$Illustration;
// for advanced use only
// view box should be automatically set by svg values
const $e62b6089fb2953cf$export$a179c88182cb9d56 = [
    0,
    0,
    209,
    119
];

});
parcelRegister("demeN", function(module, exports) {
module.exports = new URL("report-epic.c7c0b53c.svg", import.meta.url).toString();

});




parcelRegister("6eeqI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d54df378f11c8975$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d54df378f11c8975$var$messages = (0, $7qGN1.defineMessages)({
    documentTitle: {
        "id": "reports-overview-page.document-title",
        "defaultMessage": "Reports"
    },
    pageHeader: {
        "id": "reports-overview-page.page-header",
        "defaultMessage": "All reports"
    },
    learnMore: {
        "id": "software-reports.overview.list.item.learn-more",
        "defaultMessage": "Learn more"
    }
});
var $d54df378f11c8975$export$2e2bcd8739ae039 = $d54df378f11c8975$var$messages;

});

parcelRegister("2lJL8", function(module, exports) {
$parcel$export(module.exports, "ReportCardImage", () => $9bb16b6e8d6c4df0$export$3d991fa47bedf00);

var $92Lzv = parcelRequire("92Lzv");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $8wyVH = parcelRequire("8wyVH");

var $8eIcn = parcelRequire("8eIcn");

var $3JHxT = parcelRequire("3JHxT");
const $9bb16b6e8d6c4df0$export$3d991fa47bedf00 = ({ report: report })=>{
    const reportData = (0, $j4oe4.useFragment)((0, $92Lzv.default), report);
    const key = reportData.key;
    const name = reportData.name;
    const url = reportData.imageUrl;
    const isNotApplicableReason = reportData.isNotApplicableReason;
    if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9bb16b6e8d6c4df0$var$styles.image,
            isNotApplicableReason && $9bb16b6e8d6c4df0$var$styles.imageDisabled
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8wyVH.default), {
        src: url,
        width: (0, $8eIcn.IMAGE_WIDTH),
        height: (0, $8eIcn.IMAGE_HEIGHT),
        alt: name
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $9bb16b6e8d6c4df0$var$styles.image
        ])
    }, (0, $3JHxT.getImageForKey)(key, name));
};
const $9bb16b6e8d6c4df0$var$styles = {
    image: "_1reo15vq _18m915vq _4t3iqkoa",
    imageDisabled: "_kdam7g3v"
};

});
parcelRegister("92Lzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e527d0267de1c3b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67bd3b36f7e1e00c62bb3a4d33a86572>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7e527d0267de1c3b$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isMigrateTMPReportsOverviewEnabled"
        }
    ],
    "kind": "Fragment",
    "name": "image_reportsOverviewPage_ReportCardImage",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "name"
            },
            "action": "THROW",
            "path": "name"
        },
        {
            "condition": "isMigrateTMPReportsOverviewEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isNotApplicableReason"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "imageUrl"
        }
    ],
    "type": "JiraReport"
};
$7e527d0267de1c3b$var$node.hash = "275b49862af0e5654c7c344f28881698";
var $7e527d0267de1c3b$export$2e2bcd8739ae039 = $7e527d0267de1c3b$var$node;

});




parcelRegister("eeuk4", function(module, exports) {
$parcel$export(module.exports, "default", () => $46e117f4c3cdecd3$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $46e117f4c3cdecd3$var$messages = (0, $7qGN1.defineMessages)({
    projectNotFoundErrorFlagTitle: {
        "id": "software-reports-overview-page.project-not-found-error-flag-title",
        "defaultMessage": "Project not found"
    },
    projectNotFoundErrorFlagMessage: {
        "id": "software-reports-overview-page.project-not-found-error-flag-message",
        "defaultMessage": "You tried to access a project that doesn't exist, or that you don't have permission to access. Speak to your Jira admin or Project admin to get access."
    }
});
var $46e117f4c3cdecd3$export$2e2bcd8739ae039 = $46e117f4c3cdecd3$var$messages;

});




//# sourceMappingURL=jira-reports-overview-page.419e61cd.js.map
